import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Image,
  Card,
  Input,
  Form,
  Button,
  Radio,
} from '@lockerpm/design';

import AuthLogo from '../../assets/images/logos/auth-logo.svg'
import AuthBgImage from "../../assets/images/auth-bg-image.svg";

import userServices from "../../services/user";
import configurationServices from "../../services/configuration";

import global from "../../config/global";

const SettingDB = () => {
  const { t } = useTranslation();
  const locale = useSelector((state) => state.system.locale);
  const [form] = Form.useForm();
  const [callingAPI, setCallingAPI] = useState(false);

  const engine = Form.useWatch('engine', form);

  const isShowInfo = useMemo(() => {
    return engine === 'mysql'
  }, [engine])

  const handleSettingDB = async (values) => {
    setCallingAPI(true)
    await configurationServices.setup_database({
      engine: values?.engine,
      host: values?.host || null,
      port: values?.port || null,
      username: values?.username || null,
      password: values?.password || null,
      name: values?.name || null
    }).then(() => {
      global.notification('success', t('notification.success.title'), t('notification.success.setup_database.configured'))
      global.navigate("SIGN_UP", { });
    }).catch((error) => {
      global.pushError(error)
    });
    setCallingAPI(false)
  }

  useEffect(() => {
    userServices.check_exist()
  }, [])

  return (
    <div className="auth-page">
      <div
        className="setting-db w-[600px]"
        style={{
          backgroundImage: `url(${AuthBgImage})`,
          backgroundSize: 'contain',
          paddingTop: 62,
          height: 'max-content'
        }}
      >
        <div className="flex items-center justify-center mb-8">
          <Image
            className='icon-logo'
            src={AuthLogo}
            preview={false}
          />
        </div>
        <div className="flex items-center justify-center">
          <Card
            className="w-[480px]"
            bodyStyle={{
              padding: '32px'
            }}
          >
            <div className="w-full flex items-center justify-between mb-4">
              <p className="text-2xl font-semibold">
                { t('auth_pages.setting_db.title') }
              </p>
            </div>
            <Form
              form={form}
              key={locale}
              disabled={callingAPI}
              layout="vertical"
              initialValues={
                {
                  engine: 'mysql',
                  host: null,
                  port: null,
                  username: null,
                  password: null,
                  name: null
                }
              }
              onFinish={handleSettingDB}
            >
              <Form.Item
                name="engine"
                label={t('auth_pages.setting_db.engine')}
                rules={[
                  global.rules.REQUIRED(t('auth_pages.setting_db.engine')),
                ]}
              >
                <Radio.Group
                  options={[
                    {
                      label: "MySql",
                      value: "mysql"
                    },
                    {
                      label: "Sqlite",
                      value: "sqlite"
                    }
                  ]}
                />
              </Form.Item>
              {
                isShowInfo && <>
                  <Form.Item
                    name="name"
                    label={t('auth_pages.setting_db.name')}
                    help={t('auth_pages.setting_db.name_description')}
                    rules={[
                      global.rules.REQUIRED(t('auth_pages.setting_db.name'))
                    ]}
                  >
                    <Input
                      placeholder={'lockersm'}
                      size="large"
                      disabled={callingAPI}
                    />
                  </Form.Item>
                  <Form.Item
                    name="host"
                    label={t('auth_pages.setting_db.host')}
                    help={t('auth_pages.setting_db.host_description')}
                    rules={[
                      global.rules.REQUIRED(t('auth_pages.setting_db.host')),
                      global.rules.INVALID(t('auth_pages.setting_db.host'), 'HOSTNAME_IP'),
                    ]}
                  >
                    <Input
                      placeholder={'localhost'}
                      size="large"
                      disabled={callingAPI}
                    />
                  </Form.Item>
                  <Form.Item
                    name="port"
                    label={t('auth_pages.setting_db.port')}
                    help={t('auth_pages.setting_db.port_description')}
                    rules={[
                      global.rules.REQUIRED(t('auth_pages.setting_db.port')),
                      global.rules.INVALID(t('auth_pages.setting_db.port'), 'PORT'),
                    ]}
                  >
                    <Input
                      placeholder={'3306'}
                      size="large"
                      disabled={callingAPI}
                    />
                  </Form.Item>
                  <Form.Item
                    name="username"
                    label={t('auth_pages.setting_db.username')}
                    help={t('auth_pages.setting_db.username_description')}
                    rules={[
                      global.rules.REQUIRED(t('auth_pages.setting_db.username')),
                    ]}
                  >
                    <Input
                      placeholder={'lockersm'}
                      size="large"
                      disabled={callingAPI}
                    />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    label={t('auth_pages.setting_db.password')}
                    help={t('auth_pages.setting_db.password_description')}
                    rules={[
                      global.rules.REQUIRED(t('auth_pages.setting_db.password')),
                    ]}
                  >
                    <Input.Password
                      size="large"
                      placeholder={t('placeholder.password')}
                      disabled={callingAPI}
                    />
                  </Form.Item>
                </>
              }
              <Button
                className="w-full mt-6"
                size="large"
                type="primary"
                htmlType="submit"
                loading={callingAPI}
              >
                {t('button.next')}
              </Button>
            </Form>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default SettingDB;